import React from "react";
import { Container, LeftDiv, RightDiv, Suport } from "./styles";
import LoginView from "../../views/Login/index.jsx";
import bgLoginMedico from "../../assets/bg-login-medico.png";
import logo from "../../assets/logo.png";
import { deleteCookies } from "../../utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
function Login() {
  deleteCookies();

  return (
    <Container>
      <LeftDiv background={bgLoginMedico}>
        <h1>
          ”<b>Excelência</b> e <b>agilidade</b> na <b>entrega</b> dos{" "}
          <b>laudos</b> de <b>seus pacientes.</b>”
        </h1>
      </LeftDiv>

      <RightDiv>
        <h1>Área do Médico</h1>
        <LoginView />

        <img src={logo} alt="Logo CEDAP" />
      </RightDiv>
      <Suport href="https://wa.me/5547991865855" target="_blank">
        <u>Suporte</u>
        <FontAwesomeIcon icon={faWhatsapp} color="#25d366" />
      </Suport>
    </Container>
  );
}

export default Login;
